import { BehaviorSubject } from 'rxjs';

export default class UserRepository {
  userDetails$ = new BehaviorSubject(null);
  creatorToInvite$ = new BehaviorSubject(null);
  loadingUserDetails$ = new BehaviorSubject(false);
  requestedOrder$ = new BehaviorSubject(false);

  constructor({ userService }) {
    this.userService = userService;
  }

  async getCurrentUser() {
    if (!this.userService.getAccessToken()) {
      return null;
    }

    this.loadingUserDetails$.next(true);
    const userDetails = await this.userService.getCurrentUser();
    this.userDetails$.next(userDetails);
    this.loadingUserDetails$.next(false);

    return userDetails;
  }

  async changePassword(oldPassword, newPassword) {
    await this.userService.changePassword(oldPassword, newPassword);
  }

  async updateDetails(userDetails) {
    return this.userService.updateDetails(userDetails);
  }

  setIsPatientDashboardTourShown(value) {
    localStorage.setItem('isPatientDashboardTourShown', JSON.stringify(value));
    return value;
  }

  setRequestedOrder(state) {
    this.requestedOrder$.next(state);
  }

  getIsPatientDashboardTourShown() {
    const value = localStorage.getItem('isPatientDashboardTourShown');
    if (value) return JSON.parse(value);
    return null;
  }

  removeIsPatientDashboardTourShown() {
    return localStorage.removeItem('isPatientDashboardTourShown');
  }

  setIsPatientDemoAccount(value) {
    localStorage.setItem('isPatientDemoAccount', JSON.stringify(value));
    return value;
  }

  getIsPatientDemoAccount() {
    const value = localStorage.getItem('isPatientDemoAccount');
    if (value) return JSON.parse(value);
    return null;
  }

  removeIsPatientDemoAccount() {
    return localStorage.removeItem('isPatientDemoAccount');
  }

  updateUserDefaultView(defaultView) {
    return this.userService.updateUserDefaultView(defaultView);
  }

  setShouldRunSelfHelpJoyride(value) {
    localStorage.setItem('shouldRunSelfHelpJoyride', JSON.stringify(value));
    return value;
  }

  getShouldRunSelfHelpJoyride() {
    const value = localStorage.getItem('shouldRunSelfHelpJoyride');
    if (value) return JSON.parse(value);
    return null;
  }

  async changeEmailRequest() {
    return this.userService.changeEmailRequest();
  }

  async validateMfaChangeEmail({ token }) {
    return this.userService.validateMfaChangeEmail({ token });
  }

  async changeEmail({ token, email }) {
    return this.userService.changeEmail({ email, token });
  }

  async deleteUser(userId) {
    return this.userService.deleteUser(userId);
  }

  removeShouldRunSelfHelpJoyride() {
    return localStorage.removeItem('shouldRunSelfHelpJoyride');
  }
}
